import { V2_SIDEBAR_WIDTH_COLLAPSED_PX, V2_SIDEBAR_WIDTH_PX } from 'src/v2/components/_constants';

import { useAppSettings } from '~components/providers/SettingsProvider';

export function useSidebarWidth() {
  const { getSetting } = useAppSettings();
  const sidebarCollapsed = getSetting('sidebarCollapsed');
  const sidebarOffest = sidebarCollapsed ? V2_SIDEBAR_WIDTH_COLLAPSED_PX : V2_SIDEBAR_WIDTH_PX;

  return sidebarOffest;
}
